// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2wzmn","productName":"Table_productName__2ZzC0"};